// extracted by mini-css-extract-plugin
export default {"icon":"BTNSendMessage_icon__7viYU","whatsappBbutton":"BTNSendMessage_whatsappBbutton__NNXcn","whatsappBbuttonMobile":"BTNSendMessage_whatsappBbuttonMobile__mPvZy"};